import { CHANNEL_INSIGHTS_PATH } from 'constants/path';

export type RouteLink = {
  path?: string;
  handle?: { name?: string; key?: string };
};

export type NavLink = {
  path: string;
  label?: string;
  key?: string;
};

type ReportsNavLinksOptions = {
  isChannelManagerEnabled?: boolean;
  isChannelInsights?: boolean;
  channelInsightsKey: string;
  channelInsightsLabel: string;
};

export function getReportsNavLinks(
  locationPath: string,
  reportsPath: string,
  links: RouteLink[],
  {
    isChannelManagerEnabled,
    isChannelInsights,
    channelInsightsKey,
    channelInsightsLabel,
  }: ReportsNavLinksOptions,
): NavLink[] {
  const reportLinks = links
    // Hide Analytics when Channel Manager is enabled
    .filter(link => !(isChannelManagerEnabled && link.path === 'analytics'))
    .map(link => ({
      path: `${locationPath}/${reportsPath}/${link.path}`,
      label: link.handle?.name,
      key: link.handle?.key,
    }));

  if (!isChannelInsights) {
    return reportLinks;
  }

  return [
    {
      path: `${locationPath}/${reportsPath}/${CHANNEL_INSIGHTS_PATH}`,
      label: channelInsightsLabel,
      key: channelInsightsKey,
    },
    ...reportLinks,
  ];
}

export function getIntegrationsNavLinks(
  locationPath: string,
  links: RouteLink[],
  { isChannelManagerEnabled }: { isChannelManagerEnabled?: boolean },
): NavLink[] {
  return (
    links
      // Hide Order Control when Channel Manager is enabled
      .filter(link => !(isChannelManagerEnabled && link.path === 'orders-control'))
      // hide CN Integrations from left nav but keep route
      .filter(link => link.path !== 'pos-integrations')
      .map(link => ({
        path: `${locationPath}/${link.path}`,
        label: link.handle?.name,
        key: link.handle?.key,
      }))
  );
}
